/* eslint-disable import/prefer-default-export */
export const Directory = {
  listDirectoryRequest: 'LIST_DIRECTORY_PENDING',
  listDirectorySuccess: 'LIST_DIRECTORY_SUCCESS',
  listDirectoryError: 'LIST_DIRECTORY_ERROR',
};
